import React from 'react';
import styled from './Instruction.module.scss';

const MessageInstruction = ({
  heading,
  content,
  button,
  onClickBtn,
  color,
}) => {
  return (
    <div>
      <div className="d-flex flex-column justify-content-center align-items-center">
        <p className={styled.return}>{heading}</p>
        <p className={styled.note}>{content}</p>
        <div className={styled.line2} style={{ background: color }}></div>
        <div onClick={() => onClickBtn()} className={styled.btn2}>
          {button}
        </div>
      </div>
    </div>
  );
};

export default MessageInstruction;
